import axios from "@services/axios";
import { API_URL } from "@config/app";

/**
 * Loads token to prevent CSRF attacks
 */
export const getCSRFToken = async (): Promise<void> => {
  await axios.get(`${API_URL}/csrf-cookie`);
};
